import { RemovedList, Create, Edit, Barcode, List } from "../Components/index.js";

export default [
    {
        path: "/bq-store/item",
        component: List,
        name: "bq.store.item",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/item-removed",
        component: RemovedList,
        name: "bq.store.item.removed",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/barcode/show",
        component: Barcode,
        name: "bq.store.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/item/create",
        component: Create,
        name: "bq.store.item.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/inventory/item/:id/edit",
        component: Edit,
        name: "bq.store.item.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
